
import React from "react";

// reactstrap components
import {Container } from "reactstrap";

// core components

function LandingPageHeader() {
  let pageHeader = React.createRef();

  React.useEffect(() => {
    if (window.innerWidth < 991) {
      const updateScroll = () => {
        let windowScrollTop = window.pageYOffset / 3;
        pageHeader.current.style.transform =
          "translate3d(0," + windowScrollTop + "px,0)";
      };
      window.addEventListener("scroll", updateScroll);
      return function cleanup() {
        window.removeEventListener("scroll", updateScroll);
      };
    }
  });

  return (
    <>
      <div
        style={{
          background: 'linear-gradient(135deg, #667eea 0%, #764ba2 50%, #f093fb 100%)',
          minHeight: '60vh',
          paddingTop: '120px',
          position: 'relative',
          overflow: 'hidden',
          display: 'flex',
          alignItems: 'center'
        }}
        className="page-header"
        data-parallax={true}
        ref={pageHeader}
      >
        <div className="filter" style={{
          background: 'rgba(0,0,0,0.1)',
          backdropFilter: 'blur(1px)'
        }} />
        <Container>
          <div className="motto text-center">
            <div style={{
              background: 'rgba(255,255,255,0.1)',
              borderRadius: '30px',
              padding: '60px 40px',
              backdropFilter: 'blur(20px)',
              border: '1px solid rgba(255,255,255,0.2)',
              boxShadow: '0 20px 40px rgba(0,0,0,0.1)'
            }}>
              <h1 style={{
                background: 'linear-gradient(45deg, #ff6b6b, #feca57, #4facfe)',
                WebkitBackgroundClip: 'text',
                WebkitTextFillColor: 'transparent',
                backgroundClip: 'text',
                fontSize: '4rem',
                fontWeight: '900',
                marginBottom: '20px',
                textShadow: '0 4px 8px rgba(0,0,0,0.3)'
              }}>
                <b>Our Solutions</b>
              </h1>
              
              <div style={{
                width: '120px',
                height: '4px',
                background: 'linear-gradient(45deg, #ff6b6b, #feca57)',
                margin: '0 auto 30px',
                borderRadius: '2px'
              }}></div>
              
              <h3 style={{
                color: 'rgba(255,255,255,0.95)',
                fontSize: '2rem',
                fontWeight: '600',
                textShadow: '0 2px 4px rgba(0,0,0,0.3)'
              }}>
                For Your Needs
              </h3>
            </div>
          </div>
        </Container>
      </div>
    </>
  );
}

export default LandingPageHeader;
